import React from "react";
import DataTable from "react-data-table-component";

function EmployeeList({ setIsModal, setEmployeeId, setIsDeleteModal, setIsViewModal, data, deletePermission, editPermission, viewPermission, listPermission, timezone }) {

    let columnT = ""

    columnT = [
        {
            name: "EMP ID",
            selector: (row) => row.employeeCode,
            sortable: true,
            cell: (row) => <b>{row.employeeCode}</b>
        },
        {
            name: "NAME",
            selector: (row) => row.employeeName,
            sortable: true
        },
        {
            name: "USER NAME",
            selector: (row) => row.employeeUsername,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.employeeUsername}</span></div>,
            minWidth: "250px"
        },
        {
            name: "EMAIL",
            selector: (row) => row.emailId,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "MOBILE",
            selector: (row) => row.phone,
            sortable: true
        },
        {
            name: "ROLE",
            selector: (row) => row.department?.departmentName,
            sortable: true
        },
        {
            name: "TIMEZONE",
            selector: (row) => timezone[row?.timezone] || "-",
            sortable: true
        },
        {
            name: "STATUS",
            selector: (row) => { },
            sortable: true,
            cell: row => <span className={`badge ${row.status === "Completed" || row.status === "Active" ? 'bg-success' : "bg-warning"}`}>{row.status}</span>

        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            minWidth: "150px",
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {(viewPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setEmployeeId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {(editPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setEmployeeId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {(deletePermission === 1) && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setEmployeeId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            <div className="row clearfix g-3">
                <div className="col-md-12">
                    {listPermission === 1 && (
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    title={"Employee List"}
                                    columns={columnT}
                                    data={data?.employee}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )

}

export default EmployeeList;